<template>
  <div>
    <v-card tile>
      <v-card-title primary-title>
        <h3 class="headline mb-0">{{ title_hu }}</h3>
      </v-card-title>
      <v-card-text>
        <v-spacer />
        {{ action_hint_hu }}
      </v-card-text>

      <v-form @submit="search">
        <v-card-title>
          <v-text-field type="text" :label="placeholder_hu" v-model="queryString"></v-text-field>
        </v-card-title>
        <v-card-actions>
          <v-card-text v-if="searchResult"
            >{{ searchResult.features.length }} {{ hits_hu }}</v-card-text
          >
          <v-spacer />
          <v-btn type="submit" :title="hint_hu">{{ action_hu }}</v-btn>
        </v-card-actions>
      </v-form>
    </v-card>
    <v-card v-if="searchResult">
      <v-list>
        <v-list-item
          v-for="(item, index) in searchResult.features"
          :key="item.properties.placeref"
          @click="showResult(item, index)"
          v-bind:class="[index === selectedIndex ? 'highlighted' : '']"
        >
          <v-list-item-content>
            <v-list-item-title v-html="item.properties.address"></v-list-item-title>
            <v-list-item-subtitle
              v-html="item.properties.type"
              :title="resultType(item.properties.type)"
            ></v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </v-card>
  </div>
</template>

<style>
.highlighted {
  background-color: #527ec7;
}
</style>

<script>
import ApiService from '@/services/ApiService';
import mapboxgl from 'mapbox-gl';

export default {
  name: 'Search',
  props: ['map'],
  data() {
    return {
      title: 'Search',
      action: 'Search',
      title_hu: 'Cím keresés',
      action_hu: 'Keresés',
      action_hint: 'Type the address and hit enter',
      action_hint_hu: 'Gépeld be a keresett címet és üss entert',
      hint: 'Search places by address',
      hint_hu: 'Cím szerinti keresés',
      placeholder: 'Search string',
      placeholder_hu: 'kereső kifejezés, pl: Budapest',
      hits: 'hits',
      hits_hu: 'találat',
      queryString: '',
      searchResult: undefined,
      response_msg: 'Unknown error',
      response_msg_hu: 'Ismeretlen hiba',
      selectedIndex: -1,
      marker: undefined
    };
  },
  beforeDestroy() {
    this.deleteMarker();
  },
  methods: {
    search(e) {
      e.preventDefault();
      this.searchResult = undefined;
      ApiService.search(this.queryString)
        .then((response) => {
          this.searchResult = response.data.result;
          this.$data.selectedIndex = -1;
        })
        .catch((e) => {
          this.$swal(
            JSON.stringify(
              e &&
                e.response &&
                e.response.data &&
                e.response.data.meta &&
                e.response.data.meta.message
                ? e.response.data.meta.message
                : this.$data.response_msg_hu
            )
          );
        });
    },
    deleteMarker() {
      if (this.marker) {
        this.marker.remove();
        this.marker = undefined;
      }
    },
    showResult(item, index) {
      this.deleteMarker();
      this.selectedIndex = index;
      this.marker = new mapboxgl.Marker()
        .setLngLat([item.geometry.coordinates[0], item.geometry.coordinates[1]])
        .addTo(this.map);
      this.map.setCenter([item.geometry.coordinates[0], item.geometry.coordinates[1]]);
    },
    resultType(t) {
      switch (t) {
        case 'COS':
          return 'Center of Settlement / Település központja';
        case 'SHP':
          return 'Shape / Alakzat';
        case 'STR':
          return 'Street / Utca';
        case 'ADR':
          return 'Address / Cím';
        case 'POI':
          return 'Point of Interest / Látnivaló';
        case 'ZIP':
          return 'Post Code / Irányítószám';
        case 'ADM':
          return 'Administrative area / Közigazgatási terület';
        case 'LBL':
          return 'Shape label / Címke';
        case 'UND':
          return 'Undefined / Ismeretlen';
      }
    }
  }
};
</script>
